import React from 'react';
import {
  FilterCounter,
  filteredItemLabels,
} from '@/filter/components/filter-counter';

const SINGULAR = 1;

/**
 * Header with counters for Complaints page
 * @param props.totalCount {number} Total number of complaints
 * @param props.openCount {number} Number of open complaints
 * @returns {JSX.Element}
 * @constructor
 */
export function ComplaintsCounter(props) {
  const { totalCount, openCount } = props;

  return (
    <FilterCounter
      count={totalCount}
      countLabel={
        totalCount === SINGULAR
          ? filteredItemLabels.COMPLAINT
          : filteredItemLabels.COMPLAINTS
      }
      secondaryCount={openCount}
      secondaryCountLabel={filteredItemLabels.OPEN_COMPLAINTS}
    />
  );
}
